module.exports = __webpack_public_path__ + "static/media/attach-video.ad3ada90.svg";